import React from 'react';
import PropTypes from 'prop-types';
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import RenderComponents from "./RenderComponents";
import {useCurrentResolution} from "../../../../Hooks/useCurrentResolution";
import {useSelector} from "react-redux";
import {useResponsiveStyles} from "../../../../Hooks/useResponsiveStyles";

function generateStyles(styles, currentResolution, appEnv) {
    const {
        width,
        height,
        margin,
        padding = 1,
        background,
        boxShadow,
        shadowColor = '#000000',
        flexDirection = 'column',
        justifyContent = 'flex-start',
        alignItems = 'flex-start',
        border = '',
        borderColor,
        backgroundImage,
        overflow,
    } = styles;
    const backgroundImagePublicUrl = backgroundImage ? process.env.NODE_ENV === 'development' ?
        `${process.env.REACT_APP_REMOTE_HOST}${appEnv}${backgroundImage.url}` :
        `/${appEnv}` + backgroundImage.url : '';
    let borderObj = border !== "" ? {
        borderTop: `${border.split(" ")[0] || 0} solid`,
        borderRight: `${border.split(" ")[1] || 0} solid`,
        borderBottom: `${border.split(" ")[2] || 0} solid`,
        borderLeft: `${border.split(" ")[3] || 0} solid`
    } : {};
    let isPercentageHeight = height && height.substr(height.length - 1) === '%';
    let adaptiveWidth = typeof width === 'object' ? width[currentResolution] : width;
    return {
        width: adaptiveWidth,
        height: isPercentageHeight ? '100%' : height,
        padding,
        margin,
        background,
        flexDirection,
        justifyContent,
        alignItems,
        ...borderObj,
        borderColor,
        boxShadow: `${boxShadow} ${shadowColor}`,
        backgroundImage: backgroundImagePublicUrl,
        overflow
    }

}

const SectionScreenComponent = (props) => {
    const {section: {styles: stls} = {}, section, containerArrayPath, basePath, actionsContext} = props;
    const {appEnv} = useSelector(state => state.app)
    const currentResolution = useCurrentResolution();
    const resStyles = useResponsiveStyles(stls, currentResolution);
    const styles = generateStyles(resStyles, currentResolution, appEnv);

    return (
        <div
            id={`screen-section`}
            style={{
                position: 'relative',
                display: 'flex',
                overflow: 'auto',
                ...styles,
                backgroundImage: `url(${styles.backgroundImage})`,
                backgroundSize: 'cover'
            }}
        >
            {((section ? section.children : []) || []).map((element, index) => (
                <RenderComponents
                    key={index}
                    element={element}
                    containerArrayPath={containerArrayPath}
                    basePath={basePath}
                    actionsContext={actionsContext}
                />
            ))}
        </div>
    );
};
export default JsonScreenHoc(SectionScreenComponent);

SectionScreenComponent.propTypes = {
    section: PropTypes.object,
    containerArrayPath: PropTypes.string,
    basePath: PropTypes.string,
};